export const hasDuplicates = (arr: any[]): boolean => {
  const arrWithoutUndefined = arr.filter((value) => value !== undefined)
  return new Set(arrWithoutUndefined).size !== arrWithoutUndefined.length
}
